import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { UseFiltersValue } from '@components/filters';
import { IconFilter } from '@components/icons/filter';

import { useStore } from 'models/Provider';

type Props = {
  filters: UseFiltersValue;
};

export const FilterButton = observer(({ filters }: Props) => {
  const { t } = useStore();

  const filterCount = filters.state.appliedFilters.length;
  const text = t('filters.toggle') + (filterCount ? ` • ${filterCount}` : '');
  const hasFilters = filterCount > 0;

  return (
    <Button
      variant="secondary"
      iconRight={
        <IconFilter
          style={{ opacity: hasFilters ? 1 : undefined }}
          color={hasFilters ? 'blue100' : undefined}
        />
      }
      text={text}
      onClick={filters.actions.onToggleFilters}
    />
  );
});
